import React from 'react';
import {
  HomeIcon,
  BuildingOfficeIcon,
  ArrowPathIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
} from '../icons';
import AdminShell from '../components/admin/AdminShell';

const superAdminNav = [
  { to: '/super-admin', label: 'Overview', icon: HomeIcon, end: true },
  { to: '/super-admin/tenants', label: 'Tenants', icon: BuildingOfficeIcon },
  { to: '/super-admin/regeneration', label: 'Regeneration', icon: ArrowPathIcon },
  { to: '/super-admin/audit-log', label: 'Audit log', icon: ClipboardDocumentListIcon },
  { to: '/super-admin/settings', label: 'Setups', icon: Cog6ToothIcon },
];

const SuperAdminLayout = () => (
  <AdminShell
    portalLabel="Platform Admin"
    portalSub="Snwolley AI"
    navItems={superAdminNav}
    accountSettingsPath="/super-admin/account-settings"
  />
);

export default SuperAdminLayout;
